import axiosInstance from "../../apiAxios/axiosInstance";

// GET FAQ
export const getFaq = async () => {
  const response = await axiosInstance.get("/admin/demo-faq-get");
  return response.data;
};

// STORE / UPDATE FAQ
export const storeFaq = async (payload) => {
  const response = await axiosInstance.post("/admin/demo-faq-store", payload);
  return response.data;
};